






import { Component, Vue, Watch } from 'vue-property-decorator';
import BanPolicyForm from '@/components/forms/BanPolicyForm.vue';

@Component({
  components: {
    BanPolicyForm,
  },
})
export default class CreateBanPolicy extends Vue {}
